<template>
    <div>
        <template v-if="init">
            <v-tabs vertical class="overflow-fix">
                <v-tab class="d-flex justify-start text-wrap text-left">
                    Sales Partnership Sales
                </v-tab>
                <v-tab class="d-flex justify-start text-wrap text-left">
                    Sales Partnership Product Configurator
                </v-tab>

                <v-tab-item>
                    <v-card flat class="pl-9">
                        <v-card-text class="pa-0">
                            <div class="d-flex align-center mb-5 justify-center">
                                <div class="black--text text-h5 text-center">Sales Partnership Sales</div>
                            </div>
                        </v-card-text>
                            <PartenershipSaleUsersTable 
                            v-bind:companyId="parseInt(companyId)"  
                            v-bind:showUserPath="'/dashboard/spa-user/'" />
                    </v-card>
                </v-tab-item>
                <v-tab-item>
                    <v-card flat class="pl-9">
                        <v-card-text class="pa-0">
                            <div class="d-flex align-center mb-5 justify-center">
                                <div class="black--text text-h5 text-center">Sales Partnership Product Configurator</div>
                            </div>
                        </v-card-text>
                            <PartnershipProductConfiguratorUsersTable 
                            v-bind:companyId="parseInt(companyId)"  
                            v-bind:showUserPath="'/dashboard/spa-user/'" />
                    </v-card>
                </v-tab-item>
            </v-tabs>
        </template>
    </div>
</template>

<script>
import PartenershipSaleUsersTable from '../../components/PartenershipSaleUsersTable';
import PartnershipProductConfiguratorUsersTable from '../../components/PartnershipProductConfiguratorUsersTable';

    export default {
        data() {
            return {
                init : false,
                companyId : 0,
            }
        },
        components : {
            PartenershipSaleUsersTable,
            PartnershipProductConfiguratorUsersTable,
        },
        mounted()
        {
            this.init = true;
            this.companyId = this.$store.state.user.companyId;
        }
    }
</script>